<template>
  <div
    class="clinic-feature section-space--pb_90 bg-gradient"
    style="padding-top:30px;"
  >
    <div class="container" style="max-width: 1800px; text-align: center">
      <div class="row mt-5">
        <div class="col-lg-12">
          <div class="section-title-wrapper text-center section-space--mb_60">
            <h2
              class="section-title font-weight--blod wow move-up"
              style="color:white;"
            >
              An open HIS version for your hospital!
            </h2>
          </div>
        </div>
      </div>
      <iframe
        width="90%"
        height="700"
        src="https://www.youtube.com/embed/DjqP67_SnsY"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="fit_iframe"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>
